import { render, staticRenderFns } from "./StempelungenSync.vue?vue&type=template&id=0d4770ba&scoped=true"
import script from "./StempelungenSync.vue?vue&type=script&lang=js"
export * from "./StempelungenSync.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d4770ba",
  null
  
)

export default component.exports